<template>
    <el-row :gutter="10" type="flex" style="flex-wrap:wrap">
        <el-col :xs="12" :sm="12" :md="8" v-for="item in imgList" :key="item" style="margin-bottom:14px">
            <div class="imgCom"><img :src="item" alt=""></div>
        </el-col>
    </el-row>
</template>

<script>
export default {
    props:["imgList"]
}
</script>

<style lang="scss" scoped>
.imgCom{
    max-width: vw(278);
    max-height: vw(158);
    display: inline;
    margin-top: vw(14);

    img{
        width: 100%;
        height: 100%;
    }
}
</style>